import React, { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import { Button } from "../../components";
import nonMobileError from "../../assets/error.svg";
import mobileError from "../../assets/error-mobile.svg";
import { NavigateOptions } from "../../types";

type ErrorProps = {};

const Error: FC<ErrorProps> = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tryAgain, path, error } = state as NavigateOptions;
  if (!error.header) error.header = "Oops! Something went wrong";
  if (!error.message) error.message = "Please try again later";
  return (
    <div className={styles.Index}>
      <div className={styles.Card}>
        <img src={nonMobileError} alt="error" className={styles.nonMobileErrorImg} />
        <img src={mobileError} alt="error" className={styles.mobileErrorImg} />
        <h2>{error.header}</h2>
        <div>
          <p>{error.message}</p>
        </div>
        {tryAgain && (
          <Button
            onClick={() => navigate(`/${path}`)}
            size="medium"
            label="Try Again"
            style={{ width: "300px", marginTop: "50px" }}
          />
        )}
      </div>
    </div>
  );
};

export default Error;
